export const ERROR_FAILED = {
    INVALID_PLATE_NUMBER: "INVALID_PLATE_NUMBER", // Biển số xe không hợp lệ
}